import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    DocumentCategoriesAddPayload, DocumentCategoriesEditPayload
} from './document-categories.interface';

@Injectable({
    providedIn: 'root'
})
export class DocumentCategoriesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.list;

    public listDTUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.listDT;

    private findURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.find;

    private storeURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.store;

    private updateUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.update;

    private deleteUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .public;

    private changeShowEntitiesUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .showEntities;

    private changeShowContractsUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.documentCategories
            .showContracts;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: DocumentCategoriesAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: DocumentCategoriesEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    changeShowEntities(id: number) {
        return this.http.put(this.changeShowEntitiesUrl + id, {}, this.httpOptions);
    }

    changeShowContracts(id: number) {
        return this.http.put(this.changeShowContractsUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
